import { render, staticRenderFns } from "./BatteryTabs.vue?vue&type=template&id=fa27adf8"
import script from "./BatteryTabs.vue?vue&type=script&lang=js"
export * from "./BatteryTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports